<div class="d-flex align-items-center">
  <div>
    <canvas style="height: 300px; width: 300px" #doughnutChart>{{
      chart
    }}</canvas>
  </div>
  <div class="d-flex flex-column">
    <div class="text" *ngFor="let data of chartData">
      <span
        class="label"
        [style.color]="isData ? data.color : 'rgba(104, 104, 104, 0.4)'"
        >{{ data.label }}</span
      >
      <div class="value" [ngClass]="{ empty: !isData }">
        {{ data.value }}
      </div>
    </div>
  </div>
</div>
